import { CreditsPageNavItemTabs, NavItemEnum } from '../constants/routing/NavItems';
import { useHighestProductLevelFromInventory } from '../v2/hooks/inventory/useHighestProductLevel';
import { useCommerceHub } from './useCommerceHub';
import { useShouldHideDataOrSuitePage } from './useShouldHideDataOrSuitePage';
const useCreditsPageNavItemTabs = () => {
  const {
    showCommerceHub,
    loading: showCommerceHubLoading
  } = useCommerceHub();
  const shouldHideDataOrSuitePage = useShouldHideDataOrSuitePage();
  const {
    highestProductLevel,
    loading: highestProductLevelLoading,
    error: highestProductLevelError
  } = useHighestProductLevelFromInventory();
  const isFreeOrProspect = highestProductLevel === 'FREE';
  const loading = showCommerceHubLoading || highestProductLevelLoading;
  if (isFreeOrProspect) {
    return {
      loading,
      error: highestProductLevelError,
      tabs: CreditsPageNavItemTabs.filter(tab => {
        // If user does not have commerce hub from BE, don't show commerce hub tab or allow access to commerce tab.
        if (!showCommerceHub && tab === NavItemEnum.COMMERCE) {
          return false;
        }

        // If pre-seats, filter out data (operations) and suite tabs since ops hub is no longer available
        if (shouldHideDataOrSuitePage && (tab === NavItemEnum.DATA || tab === NavItemEnum.SUITE)) {
          return false;
        }
        return true;
      })
    };
  }
  return {
    tabs: [],
    loading,
    error: highestProductLevelError
  };
};
export default useCreditsPageNavItemTabs;